// The following eslint-disable was automated from the ts conversion
/* eslint-disable @typescript-eslint/no-explicit-any,@typescript-eslint/explicit-module-boundary-types */
import React, { useState, useRef } from 'react'
import validatePresence from '../lib/validatePresence'
import StyledTextField from './StyledTextField'
import AuthenticityToken from './AuthenticityToken'
import InstructionsText from './InstructionsText'
import NavigationLink from './NavigationLink'
import SubmitButton from './SubmitButton'

type Props = {
  onSubmit: () => void
  paths: any
}

const ResetPassword = ({ onSubmit, paths }: Props) => {
  const [errors, setErrors] = useState({})
  const [emailFieldValue, setEmailFieldValue] = useState('')
  const formRef = useRef(null)

  /* @ts-expect-error auto-src: strict-conversion */
  const addError = (field, message) => {
    /* @ts-expect-error auto-src: strict-conversion */
    if (errors[field] !== message) {
      /* @ts-expect-error auto-src: strict-conversion */
      errors[field] = message
      setErrors(errors)
    }
  }

  const formHasErrors = () => {
    const emailError = validatePresence('email', emailFieldValue)

    setErrors({
      email: emailError,
    })

    return emailError
  }

  /* @ts-expect-error auto-src: strict-conversion */
  const handleFormSubmit = (event) => {
    if (formHasErrors()) {
      event.preventDefault()
      event.stopPropagation()
    } else {
      onSubmit()
      /* @ts-expect-error auto-src: strict-conversion */
      formRef.current.submit()
    }
  }

  /* @ts-expect-error auto-src: strict-conversion */
  const handleEmailChange = (event) => {
    const eventTargetValue = event.target.value

    setEmailFieldValue(eventTargetValue)

    if (eventTargetValue) {
      const error = validatePresence('email', eventTargetValue)

      addError('email', error)
    }
  }

  return (
    <form
      ref={formRef}
      action={paths.createPassword}
      autoComplete="off"
      method="post"
      onSubmit={handleFormSubmit}
    >
      <AuthenticityToken />
      <InstructionsText>
        Enter your email to reset your password
      </InstructionsText>
      <StyledTextField
        FormHelperTextProps={{
          /* @ts-expect-error auto-src: non-strict-conversion */
          error: Boolean(errors.email),
        }}
        /* @ts-expect-error auto-src: non-strict-conversion */
        helperText={errors.email}
        label="Email"
        name="user[email]"
        onBlur={handleEmailChange}
        onChange={handleEmailChange}
      />
      <SubmitButton label="RESET PASSWORD" />
      <NavigationLink href={paths.newSession}>Sign in</NavigationLink>
    </form>
  )
}

export default ResetPassword
